import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProfileProvider } from './contexts/ProfileContext';
import { UnreadMessagesProvider } from './contexts/UnreadMessagesContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import EmployeeList from './pages/EmployeeList';
import Tasks from './pages/Tasks';
import Chat from './pages/Chat';
import Profile from './pages/Profile';
import TestProfiles from './pages/TestProfiles';
import AlertSettingsPage from './pages/AlertSettingsPage';
import GestionNovedades from './pages/GestionNovedades';
import Novedades from './pages/Novedades';
import ReporteNovedades from './pages/ReporteNovedades';
import WebcamMonitor from './pages/WebcamMonitor';

function App() {
  return (
    <AuthProvider>
      <ProfileProvider>
        <UnreadMessagesProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            
            {/* Rutas para empleados y supervisores */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tasks"
              element={
                <ProtectedRoute>
                  <Tasks />
                </ProtectedRoute>
              }
            />
            <Route
              path="/chat"
              element={
                <ProtectedRoute>
                  <Chat />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/alert-settings"
              element={
                <ProtectedRoute>
                  <AlertSettingsPage />
                </ProtectedRoute>
              }
            />

            {/* Rutas solo para supervisores */}
            <Route
              path="/employee-list"
              element={
                <ProtectedRoute requireSupervisor>
                  <EmployeeList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion-novedades"
              element={
                <ProtectedRoute requireSupervisor>
                  <GestionNovedades />
                </ProtectedRoute>
              }
            />
            <Route
              path="/webcam-monitor"
              element={
                <ProtectedRoute requireSupervisor>
                  <WebcamMonitor />
                </ProtectedRoute>
              }
            />

            {/* Rutas solo para empleados */}
            <Route
              path="/novedades"
              element={
                <ProtectedRoute requireEmployee>
                  <Novedades />
                </ProtectedRoute>
              }
            />

            {/* Ruta para reporte de novedades */}
            <Route
              path="/reporte-novedades"
              element={
                <ProtectedRoute>
                  <ReporteNovedades />
                </ProtectedRoute>
              }
            />

            {/* Ruta para pruebas */}
            <Route path="/test-profiles" element={<TestProfiles />} />
            
            {/* Ruta raíz - redirige según el rol */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Navigate to="/dashboard" replace />
                </ProtectedRoute>
              }
            />
          </Routes>
        </UnreadMessagesProvider>
      </ProfileProvider>
    </AuthProvider>
  );
}

export default App;
